import styled from "styled-components";

// theme is now fully typed
export const LogoWrapper = styled.div`
  img {
    height: 50px;
  }
`;
